import { Component, Input, OnInit } from '@angular/core';
import { LabelsProviderPipe } from 'src/app/pipes/labels-provider/labels-provider.pipe';

@Component({
  selector: 'app-not-applicable-label',
  templateUrl: './not-applicable-label.component.html',
  styleUrls: ['./not-applicable-label.component.scss'],
})
export class NotApplicableLabelComponent implements OnInit {
  @Input() public tooltipDynamicText: string;

  private readonly _notApplicableString: string;

  constructor(private readonly _labelsProviderPipe: LabelsProviderPipe) {
    this._notApplicableString = this._labelsProviderPipe.transform('common.notApplicable');
  }

  public ngOnInit(): void {
    if (!this.tooltipDynamicText) {
      this.tooltipDynamicText = this._notApplicableString;
    }
  }
}
